import React from 'react'
import PropTypes from 'prop-types'
import {
  Grid,
  TextField,
  Tooltip,
  Typography,
  InputAdornment,
  CircularProgress,
  Divider,
  Fab,
} from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import AddIcon from '@material-ui/icons/Add'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SaveIcon from '@material-ui/icons/Save'

import { Page, Header, SelecionarData, CustomButton, SecaoGenerica } from 'components'
import { useExameIdentificacaoCadaverica } from './hooks/useExameIdentificacaoCadaverica'
import { useStyles } from './ExameIdentificacaoCadaverica.styles'

export const ExameIdentificacaoCadaverica = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    examesDoCaso,
    processandoExame,
    processandoConfirmacao,
    arrayFiliacao,
    form,
    handleAdicionarFiliacao,
    parseDataLocal,
    handleDateChange,
    handleVoltar,
    handleConfirmar,
  } = useExameIdentificacaoCadaverica()

  const isFormInvalid =
    !form.formState.values.tipoDocumento ||
    !form.formState.values.numeroDocumento ||
    !form.formState.values.orgaoEmissorDocumento ||
    !form.formState.values.dataNascimento ||
    !form.formState.values.exBase ||
    !form.formState.values.filiacao0?.trim().length

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />

      {processandoExame ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <>

          <Grid container spacing={2} className={classes.corpoFormulario}>
            <Grid item md={6} sm={6} xs={12} className={classes.item}>
              <AutocompleteNative
                name="tipoDocumento"
                noOptionsText="Sem informações"
                options={[
                  'REGISTRO CIVIL',
                  'PRONTUÁRIO CIVIL',
                  'PRONTUÁRIO DE IDENTIFICAÇÃO CRIMINAL',
                  'CARTEIRA DE TRABALHO',
                  'CARTEIRA PROFISSIONAL',
                  'PASSAPORTE',
                  'CARTEIRA DE IDENTIFICAÇÃO FUNCIONAL',
                  'OUTRO',
                ]}
                value={form.formState.values.tipoDocumento || null}
                onChange={(event, newValue) => {
                  form.handleChangeNewValueByNameProperty(event, newValue, 'tipoDocumento')
                }}
                getOptionLabel={(option) => option}
                renderOption={(option) => option}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="TIPO DE DOCUMENTO"
                    error={form.hasError('tipoDocumento')}
                    helperText={
                      form.hasError('tipoDocumento') ? form.formState.errors.tipoDocumento[0] : null
                    }
                    required
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item md={12} sm={12} xs={12} container spacing={2}>
              <Grid item md={6} sm={6} xs={12} className={classes.item}>
                <TextField
                  fullWidth
                  label="Nº DO DOCUMENTO"
                  name="numeroDocumento"
                  onChange={form.handleChange}
                  value={form.formState.values.numeroDocumento || ''}
                  required
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item md={6} sm={6} xs={12} className={classes.item}>
                <TextField
                  fullWidth
                  label="ÓRGÃO EMISSOR"
                  name="orgaoEmissorDocumento"
                  onChange={form.handleChange}
                  value={form.formState.values.orgaoEmissorDocumento || ''}
                  required
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>

            <Grid item md={12} sm={12} xs={12} className={classes.item}>
              <TextField
                fullWidth
                label="Nome completo"
                name="nome"
                onChange={form.handleChange}
                value={form.formState.values.nome || ''}
                required
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item md={12} sm={12} xs={12} className={classes.groupFiliacao}>
              {arrayFiliacao.map((input, index) => (
                <TextField
                  key={input}
                  error={form.hasError(`${input}`)}
                  fullWidth
                  helperText={form.hasError(`${input}`) ? form.formState.errors[`${input}`][0] : null}
                  className={classes.inputForm}
                  label={`FILIAÇÃO (${index + 1})`}
                  name={input}
                  onChange={form.handleChange}
                  variant="outlined"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={form.formState.values[input] || ''}
                  InputProps={{
                    endAdornment: index + 1 === arrayFiliacao.length && (
                      <InputAdornment position="start">
                        <Tooltip title="Adicionar filiação">
                          <Fab
                            color="primary"
                            size="small"
                            onClick={handleAdicionarFiliacao}
                            className={classes.botaoAddFiliacao}
                          >
                            <AddIcon />
                          </Fab>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              ))}
            </Grid>

            <Grid item md={12} sm={12} xs={12} container spacing={2} alignItems="center">
              <Grid item md={6} sm={6} xs={12} className={classes.item}>
                <TextField
                  fullWidth
                  label="NATURALIDADE"
                  name="naturalidade"
                  onChange={form.handleChange}
                  value={form.formState.values.naturalidade || ''}
                  variant="outlined"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item md={6} sm={6} xs={12} className={classes.item} style={{ marginTop: '8px' }}>
                <SelecionarData
                  dataBD={
                    form.formState.values.dataNascimento
                      ? parseDataLocal(form.formState.values.dataNascimento)
                      : null
                  }
                  withoutTime
                  required
                  name="dataNascimento"
                  callback={handleDateChange}
                  label="Data do nascimento"
                />
              </Grid>
            </Grid>
          </Grid>


          <SecaoGenerica titulo="EXAME REALIZADO COMO BASE PARA A IDENTIFICAÇÃO">
            <Grid container spacing={2} className={classes.corpoFormulario}>
              <Grid item md={12} sm={12} xs={12} className={classes.field}>
                <AutocompleteNative
                  name="exBase"
                  noOptionsText="Sem informações"
                  value={form.formState.values.exBase || null}
                  options={examesDoCaso}
                  onChange={(event, newValue) =>
                    form.handleChangeNewValueByNameProperty(event, newValue, 'exBase')
                  }
                  getOptionLabel={(option) =>
                    `${option.numeroExame} - ${option.exSol?.tipoEx ? option.exSol.tipoEx.nome : 'Tipo não identificado'
                    }`
                  }
                  renderOption={(option) => (
                    <>
                      {option.numeroExame} -{' '}
                      {option.exSol?.tipoEx ? option.exSol.tipoEx.nome : 'Tipo não identificado'}
                    </>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="EXAME NECROPAPILOSCÓPICO, ANTROPOLÓGICO, DNA OU IDENTIFICAÇÃO ODONTOLÓGICA RELACIONADO AO CASO"
                      required
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </SecaoGenerica>

          <Divider className={classes.divider} />

          <Grid container justifyContent="space-between" spacing={1} className={classes.navigationContainer}>
            <Grid item>
              <CustomButton
                variant="outlined"
                onClick={handleVoltar}
                startIcon={<ArrowBackIcon />}
              >
                Voltar
              </CustomButton>
            </Grid>
            <Grid item>
              <CustomButton
                variant="contained"
                color="primary"
                onClick={handleConfirmar}
                disabled={isFormInvalid}
                isLoading={processandoConfirmacao}
                startIcon={<SaveIcon />}
              >
                Confirmar
              </CustomButton>
            </Grid>
          </Grid>
        </>
      )}
    </Page>
  )
}

ExameIdentificacaoCadaverica.propTypes = {
  route: PropTypes.shape({
    titulo: PropTypes.string.isRequired,
    secao: PropTypes.string.isRequired,
  }).isRequired,
}
